import * as Yup from "yup";
import { APP_CONFIG } from "../../../constants/constants";
import { phoneRegex } from "../../../utils/validation";

// form field names
export type TFormFieldNames =
  | "user_id"
  | "password"
  | "user_description"
  | "is_active"
  | "use_two_factor"
  | "use_geozone_labels"
  | "contact_name"
  | "contact_phone_number"
  | "contact_email"
  | "timezone"
  /*"enable_sso_to_visatracks" |*/
  | "default_overlay"
  | "mapDefault"
  | "user_state"
  | "session_timeout"
  | "first_login_page"
  | "selected_groups"
  | "default_acl_role"
  | "maximum_access_level"
  | "user_acls";

// initial values for the form
export const userDetailsInitialValues = {
  user_id: "",
  password: "",
  user_description: "",
  mapDefault: "0",
  is_active: false,
  use_two_factor: false,
  use_geozone_labels: false,
  contact_name: "",
  contact_phone_number: "",
  contact_email: "",
  timezone: "",
  // enable_sso_to_visatracks: false,
  default_overlay: "",
  user_state: "",
  session_timeout: 0,
  first_login_page: "",
  selected_groups: [] as string[] | { label: string; value: string }[],
  all_groups: false,
  default_acl_role: "",
  maximum_access_level: 0,
  user_acls: [],
};

// validation schema for the form
export const userDetailsYupValidationSchema = Yup.object().shape({
  user_id: Yup.string().required("User ID is required"),
  password: Yup.string().min(
    APP_CONFIG.PASSWORD.MIN_LENGTH,
    `Password is too short - should be minimum ${APP_CONFIG.PASSWORD.MIN_LENGTH} chars`
  ),
  user_description: Yup.string().required("User Description is required"),
  contact_email: Yup.string()
    .required("Email is required")
    .matches(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Please enter a valid email address"
    ),
  mapDefault: Yup.string(),
  timezone: Yup.string().required("Timezone is required"),
  is_active: Yup.boolean().required("Is Active is required"),
  use_geozone_labels: Yup.boolean().required("Use Geozone Labels is required"),
  contact_phone_number: Yup.string().matches(phoneRegex, "Invalid phone"),
  // session timeout to be less than or equal to 64855 (45 days * 24 hours * 60 minites + 55 minutes)
  session_timeout: Yup.number()
    .max(
      64855 * 60, // convert to seconds for validation
      "Session Timeout must be less than or equal to 45 days 55 minutes (maximum value 1080:55)" // 64855 minutes
    )
    .required("Session Timeout is required"),
  first_login_page: Yup.string().required("First Login Page is required"),
  selected_groups: Yup.array()
    .of(Yup.object())
    .when("all_groups", {
      is: false,
      then: (schema) =>
        schema.min(
          1,
          'Either select "All Groups" option above, or at least one group from the option below'
        ),
      otherwise: (schema) => schema,
    }),

  // TODO role feature is not implemented yet
});
